// src/components/Hero.js
import React , { memo } from 'react';
import '../styles/magazine.scss';
import { Link } from 'react-router-dom';

/*adjust-top-center  "adjust-bottom-left" "adjust-center-right""adjust-center"*/
const Magazine = memo(function Magazine() {
  const immagini = [
    { image: '/images/Michelangelo/Michelangelo_15.JPG', title: ["MICHELANGELO VIZZINI", "17:23"], className: "", link: "/michelangelo" },
    { image: '/images/Maddalena/Maddalena_9.jpg', title: ["MADDALENA SVEVI", "MAN IN TOWN"], className: "", link: "/maddalena" },
    { image: '/images/MeganNextGen/MeganPresss.jpeg', title: ["MEGAN RIA", "NEXT GEN MAGAZINE"], className: "", link: "/MeganNextGen" },
    { image: '/images/MeganTMRW/MeganTMRW_1.jpg', title: ["MEGAN RIA", "SELIN MAGAZINE"], className: "", link: "/MeganTMRW" },
    { image: '/images/33Magazine/Cover33.jpg', title: ["33 MAGAZINE"], className: "", link: "/trentatre" },
    { image: '/images/MeganDue/MeganDue_4.jpg', title: ["MEGAN RIA", "33 MAGAZINE"], className: "adjust-center2", link: "/TrentatreRia" },
    { image: '/images/GMARO/GMARO_1.jpg', title: ["GMARO"], className: "", link: "/gmaro" },
    { image: '/images/MOB/MOB_3.jpg', title: ["MOB MAGAZINE"], className: "", link: "/mob" },
    { image: '/images/OFFTOWN/OFFTOWN_4.jpg', title: ["OFFTOWN MAGAZINE"], className: "adjust-center", link: "/Offtown" },
    { image: '/images/Virginia/Virginia_14.jpg', title: ["VIRGINIA MONTEMAGGI", "CHICLE MAGAZINE"], className: "", link: "/virginia" },
    
  ];

  return (
    <section className="magazine">
      <div className="image-grid">
        {immagini.map((img, index) => (
          <div key={index} className={`image-grid__item ${img.className}`}>
            <Link to={img.link}>
              <img src={img.image} alt={img.title.join(' ')} loading="lazy" />
              <h3 className="image-grid__title">
                {img.title.map((line, i) => (
                  <span key={i}>
                    {line}
                    {i < img.title.length - 1 && <br />}
                  </span>
                ))}
              </h3>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
});


export default Magazine;